import PropTypes from 'prop-types';

import styles from './styles/styles.module.css';

function GreyButton({
  text,
  onClick,
  iconLeft,
  iconRight,
  disabled,
  width,
  height,
  fontSize,
  fontWeight,
  className,
  backgroundCol,
  tectColor,
}) {
  return (
    <button
      className={`${styles.greyButton} ${className || ''}`}
      onClick={onClick}
      disabled={disabled}
      type="button"
      style={{
        width: width || 'auto',
        height: height || 'auto',
        fontSize: fontSize || 'inherit',
        fontWeight: fontWeight || 'inherit',
        backgroundColor: backgroundCol,
        color: tectColor,
      }}
    >
      {iconLeft && <img src={iconLeft} alt="с" />}
      {text}
      {iconRight && <img src={iconRight} alt="" />}
    </button>
  );
}

export default GreyButton;

GreyButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  iconLeft: PropTypes.string,
  iconRight: PropTypes.string,
  tectColor: PropTypes.string,
  disabled: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fontWeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  backgroundCol: PropTypes.string,
};
